import { LogIn, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";

export const UserChip = ({ compact = false }) => {
  const { user, loading, login, logout } = useAuth();
  const { t } = useLang();
  if (loading) return null;
  if (!user) {
    return (
      <button onClick={login} className={`btn-ghost flex items-center justify-center gap-2 ${compact ? "px-3 py-1 text-xs" : "py-3 text-sm w-full"}`} data-testid="google-signin-btn">
        <LogIn size={compact ? 14 : 16} /> {t.signIn}
      </button>
    );
  }
  return (
    <div className={`panel flex items-center gap-2 ${compact ? "pl-1 pr-2 py-1" : "px-3 py-2"}`} data-testid="user-chip">
      {user.picture ? (
        <img src={user.picture} alt="" referrerPolicy="no-referrer" className={`${compact ? "w-6 h-6" : "w-8 h-8"} rounded-full object-cover`} data-testid="user-avatar" />
      ) : (
        <span className={`${compact ? "w-6 h-6 text-xs" : "w-8 h-8 text-sm"} rounded-full bg-[var(--gold)] text-[var(--kg-red-dark)] font-display font-black flex items-center justify-center`}>{user.name?.[0]}</span>
      )}
      {!compact && <span className="text-sm font-bold truncate max-w-[140px]" data-testid="user-name">{user.name}</span>}
      <button onClick={logout} title={t.signOut} className="text-[var(--text-light)]/60 hover:text-[var(--gold)] transition-colors" data-testid="signout-btn"><LogOut size={compact ? 14 : 16} /></button>
    </div>
  );
};
